// 401s from these endpoints mean wrong credentials, not an expired session —
// the response interceptor must not run its refresh-then-logout flow on them.
// /auth/verify-token is deliberately absent: a 401 there means the session
// cookie expired, and refreshing is exactly right.
export const CREDENTIAL_AUTH_PATHS = [
  "/auth/phone-login",
  "/auth/authenticate-code",
  "/auth/donor-register",
  "/auth/forgot-password",
  "/auth/refresh",
];

export const isCredentialAuthUrl = (url) =>
  CREDENTIAL_AUTH_PATHS.some((path) => url?.includes(path));
